import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import errorImg from "../assets/img/errorPage.png";
import { useTranslation } from "react-i18next";
import { tokens as c } from "../theme";

// The "page not found" page. Picture and message side by side from 600 px
// up, stacked on a phone (Q19); dark text that can be read (the orange stays
// as the accent line), and the way home as a real button.
const Error = () => {
  const { t, i18n } = useTranslation();
  return (
    <Box
      component="main"
      dir={i18n.dir()}
      sx={{
        minHeight: "100vh",
        "@supports (min-height: 100dvh)": { minHeight: "100dvh" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 4,
        boxSizing: "border-box",
        bgcolor: c.SCREEN_BG,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          gap: { xs: 2, sm: 4 },
          width: "100%",
          maxWidth: 760,
          textAlign: { xs: "center", sm: "start" },
        }}
      >
        <Box
          component="img"
          src={errorImg}
          alt=""
          sx={{ width: { xs: 140, sm: 200 }, height: { xs: 140, sm: 200 }, objectFit: "scale-down", flex: "none" }}
        />
        <Box
          sx={{
            minWidth: 0,
            // Stacked on a phone the text takes the full width so it wraps
            // (a centred column item would size to its longest line).
            width: { xs: "100%", sm: "auto" },
            flex: { sm: "1 1 auto" },
            boxSizing: "border-box",
            borderTop: { xs: `4px solid ${c.ACCENT}`, sm: 0 },
            borderInlineStart: { xs: 0, sm: `4px solid ${c.ACCENT}` },
            pt: { xs: 2, sm: 0.5 },
            pb: { sm: 0.5 },
            paddingInlineStart: { xs: 0, sm: 3 },
          }}
        >
          <Typography component="h1" sx={{ fontSize: { xs: 28, sm: 36 }, fontWeight: 700, lineHeight: 1.3, color: c.INK, overflowWrap: "anywhere" }}>
            {t("page_not_not_found")}
          </Typography>
          <Typography component="p" sx={{ fontSize: { xs: 16, sm: 18 }, lineHeight: 1.55, color: c.INK_2, my: 2 }}>
            {t("page_not_not_found_text")}
          </Typography>
          <Button component={RouterLink} to="/" variant="contained" size="large" startIcon={<HomeOutlinedIcon />}>
            {t("go_to_home")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Error;
